import { IpScope } from "../Core/IpScope";
import { DtoBase } from "../Utils/DtoBase";
import { ValueEncoder } from "../Utils/ValueEncoder";

export abstract class ProtocolSettings extends DtoBase {

	public Name: string;
	public Description: string;
	public Source: string;
	public IsDefault: boolean;
	public IpScope: IpScope;
	public BlockIpScope: IpScope;
	public UseCount: number;

	constructor() {
		super();

		this.Name = "";
		this.Description = "";
		this.Source = "";
		this.IsDefault = false;
		this.IpScope = new IpScope();
		this.BlockIpScope = new IpScope();
		this.UseCount = 0;
	}

	public get HasName(): boolean {
		return !!this.Name;
	}

	public get HasDescription(): boolean {
		return !!this.Description;
	}

	public get HasSource(): boolean {
		return !!this.Source;
	}

	public get HasIpScope(): boolean {
		return (!!this.IpScope && !this.IpScope.IsEmpty);
	}

	public get HasBlockIpScope(): boolean {
		return (!!this.BlockIpScope && !this.BlockIpScope.IsEmpty);
	}


	public abstract get SettingsType(): string;
	public abstract get Summary(): string;

	public toString(): string {
		return this.Name;
	}

	public ToString(): string {
		return this.toString();
	}

	public Copy(other: ProtocolSettings): void {
		this.ClearPersistenceProps();
		this.Name = "";
		this.Description = "";
		this.Source = "";
		this.IsDefault = false;
		this.IpScope.Clear();
		this.BlockIpScope.Clear();

		this.CopyPersistenceProps(other);

		if (other.HasName)
			this.Name = other.Name;

		if (other.HasDescription)
			this.Description = other.Description;

		if (other.HasSource)
			this.Source = other.Source;

		this.IsDefault = other.IsDefault;

		if (other.HasIpScope)
			this.IpScope.Copy(other.IpScope);

		if (other.HasBlockIpScope)
			this.BlockIpScope.Copy(other.BlockIpScope);

		this.UseCount = other.UseCount;
	}

	public abstract Clone(): ProtocolSettings;

	public Equals(obj: any): boolean {
		if (!super.Equals(obj))
			return false;

		if (!(obj instanceof ProtocolSettings))
			return false;
		let other: ProtocolSettings = (obj as ProtocolSettings);

		return (this.Name === other.Name &&
			this.Description === other.Description &&
			this.Source === other.Source &&
			this.IsDefault === other.IsDefault &&
			this.IpScope.Equals(other.IpScope) &&
			this.BlockIpScope.Equals(other.BlockIpScope));
	}

	public Write(obj: any, context: any): void {

		// Called by subclass Write methods

		super.Write(obj, context);

		if (this.HasName)
			obj.name = this.Name;

		if (this.HasDescription)
			obj.description = this.Description;

		if (this.HasSource)
			obj.source = this.Source;

		if (this.IsDefault)
			obj.is_default = ValueEncoder.EncodeBoolean(this.IsDefault);

		if (this.HasIpScope) {
			context[IpScope.ObjSer_ObjectName] = "ip_scope";
			this.IpScope.Write(obj, context);
		}

		if (this.HasBlockIpScope) {
			context[IpScope.ObjSer_ObjectName] = "block_ip_scope";
			this.BlockIpScope.Write(obj, context);
		}

		if (this.UseCount > 0) {
			obj.use_count = ValueEncoder.EncodeInteger(this.UseCount);
		}
	}

	public Read(obj: any, context: any): void {

		// Called by subclass Read methods

		super.Read(obj, context);

		if (obj.name !== undefined)
			this.Name = obj.name;

		if (obj.description !== undefined)
			this.Description = obj.description;

		if (obj.source !== undefined)
			this.Source = obj.source;

		if (obj.is_default !== undefined)
			this.IsDefault = ValueEncoder.DecodeBoolean(obj.is_default);

		if (obj.ip_scope !== undefined) {
			context[IpScope.ObjSer_ObjectName] = "ip_scope";
			this.IpScope.Read(obj, context);
		}

		if (obj.block_ip_scope !== undefined) {
			context[IpScope.ObjSer_ObjectName] = "block_ip_scope";
			this.BlockIpScope.Read(obj, context);
		}

		if (obj.use_count !== undefined) {
			this.UseCount = ValueEncoder.DecodeInteger(obj.use_count);
		}
	}

}

